"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TipoMaterialChaveModelo = void 0;
var TipoMaterialChaveModelo = /** @class */ (function () {
    function TipoMaterialChaveModelo(_a) {
        var _b = _a._id, _id = _b === void 0 ? { TIPO_MAT: '', CHAVE_MODELO: '' } : _b, _c = _a.TIPO_MAT, TIPO_MAT = _c === void 0 ? '' : _c, _d = _a.CHAVE_MODELO, CHAVE_MODELO = _d === void 0 ? '' : _d, _e = _a.DESCRICAO, DESCRICAO = _e === void 0 ? '' : _e;
        this._id = _id;
        this.TIPO_MAT = TIPO_MAT;
        this.CHAVE_MODELO = CHAVE_MODELO;
        this.DESCRICAO = DESCRICAO;
    }
    return TipoMaterialChaveModelo;
}());
exports.TipoMaterialChaveModelo = TipoMaterialChaveModelo;
//# sourceMappingURL=TipoMaterialChaveModelo.js.map